import { _ } from "../../core/polyglot/polyglot.js";
import AbstractAgencyBillingStatus from "./AbstractAgencyBillingStatus.js";

let instance;

/**
 * An agency with this status isn't billed because it is not used anymore.
 */
export default class ArchiveAgencyBillingStatus extends AbstractAgencyBillingStatus {
	label() {
		return _("Archived agency");
	}

	static getType() {
		return "Archive";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
